import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/targets/activityLog/$id')({
  beforeLoad: () => getTitleContextSlice('Activity Log'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
